import React, { useEffect, useState } from 'react';
import api from '../api/axios';

export interface LinkedCustomer {
  id: number;
  company_name?: string;
  contact_person?: string;
  phone?: string;
}

interface Props {
  threadId: number;
  onCreated: (customer: LinkedCustomer) => void;
  onCancel: () => void;
}

// So'rovdan mijozni bazaga (Client, /clients) qo'shish formasi - qiymatlar
// GET /inquiries/{id}/customer-prefill dan to'ldiriladi, xodim tahrirlaydi.
const InquiryCustomerForm: React.FC<Props> = ({ threadId, onCreated, onCancel }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    client_type: 'individual' as 'individual' | 'company',
    name: '',
    company_name: '',
    phone: '',
    email: '',
    telegram: '',
  });

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    api.get(`/inquiries/${threadId}/customer-prefill`)
      .then(r => {
        if (cancelled) return;
        setForm(f => ({
          ...f,
          name: r.data.customer_name || '',
          phone: r.data.customer_phone || '',
          telegram: r.data.telegram || '',
        }));
      })
      .catch((e: any) => { if (!cancelled) setError(e.response?.data?.detail || "Ma'lumotlarni yuklab bo'lmadi"); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [threadId]);

  const f = (key: keyof typeof form, value: string) => setForm(prev => ({ ...prev, [key]: value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.name.trim()) { setError('Ism majburiy'); return; }
    if (form.client_type === 'company' && !form.company_name.trim()) { setError('Kompaniya nomi majburiy'); return; }
    setSaving(true);
    setError('');
    try {
      const res = await api.post(`/inquiries/${threadId}/create-customer`, {
        client_type: form.client_type,
        name: form.name.trim(),
        company_name: form.client_type === 'company' ? form.company_name.trim() : null,
        phone: form.phone.trim() || null,
        email: form.email.trim() || null,
        telegram: form.telegram.trim() || null,
      });
      onCreated(res.data);
    } catch (e: any) {
      const detail = e.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : "Mijozni qo'shib bo'lmadi");
    } finally {
      setSaving(false);
    }
  };

  const inputCls = 'w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

  return (
    <form onSubmit={handleSubmit} className="bg-white border-b px-4 py-3 space-y-2">
      <p className="text-sm font-semibold text-gray-700">Mijozni bazaga qo'shish</p>
      {loading ? (
        <p className="text-xs text-gray-400">Yuklanmoqda...</p>
      ) : (
        <>
          <div className="flex gap-2 text-xs">
            {(['individual', 'company'] as const).map(t => (
              <button type="button" key={t} onClick={() => f('client_type', t)}
                className={`px-2 py-1 rounded-lg border ${form.client_type === t ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600'}`}>
                {t === 'individual' ? 'Jismoniy shaxs' : 'Kompaniya'}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {form.client_type === 'company' && (
              <input value={form.company_name} onChange={e => f('company_name', e.target.value)}
                placeholder="Kompaniya nomi *" className={inputCls} />
            )}
            <input value={form.name} onChange={e => f('name', e.target.value)}
              placeholder={form.client_type === 'company' ? 'Kontakt shaxs *' : 'Ism *'} className={inputCls} />
            <input value={form.phone} onChange={e => f('phone', e.target.value)}
              placeholder="Telefon" className={inputCls} />
            <input value={form.telegram} onChange={e => f('telegram', e.target.value)}
              placeholder="Telegram" className={inputCls} />
            <input value={form.email} onChange={e => f('email', e.target.value)} type="email"
              placeholder="Email" className={inputCls} />
          </div>
        </>
      )}
      {error && <p className="text-xs text-red-600">{error}</p>}
      <div className="flex gap-2 justify-end">
        <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs rounded-lg border text-gray-600 hover:bg-gray-50">
          Bekor qilish
        </button>
        <button type="submit" disabled={saving || loading}
          className="px-3 py-1.5 text-xs rounded-lg bg-green-600 text-white font-medium hover:bg-green-700 disabled:opacity-50">
          {saving ? 'Saqlanmoqda...' : 'Bazaga qo\'shish'}
        </button>
      </div>
    </form>
  );
};

export default InquiryCustomerForm;
